// theirs
import { AnimatePresence } from 'framer-motion'
import React, { useEffect } from 'react'
import { ContentDataModel } from '../interfaces'
import { eventBus } from './event-bus'

export interface InViewFrameContextInterface {
    content: ContentDataModel
}

export const InViewFrameContext =
    React.createContext<InViewFrameContextInterface | null>(null)

export function InViewIcon({
    inView,
    content,
}: {
    inView: boolean
    content: ContentDataModel
}) {
    useEffect(() => {
        if (inView) {
            eventBus.dispatch('canvasType', {
                message:
                    content.contentCanvasType === undefined
                        ? 'NoCanvasInViewStopAnimation'
                        : content.contentCanvasType,
            })
            eventBus.dispatch('contentId', {
                message: content.contentId,
            })
        }
    }, [content.contentId, content.contentCanvasType, inView])
    return <AnimatePresence exitBeforeEnter></AnimatePresence>
}
